module.exports = __webpack_public_path__ + "img/MCD_Background_Unternehmen_Wood.8948daa5.jpg";